import React, { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { useLang } from "../i18n/LanguageContext";
import LanguageSwitcher from "./LanguageSwitcher";

const Logo = () => (
  <a href="#top" data-testid="navbar-logo" className="flex shrink-0 items-center" aria-label="CEO Travel home">
    {/* Intentionally invisible — brand is the BIG hero logo */}
    <span className="sr-only">CEO Travel</span>
  </a>
);

export const Navbar = ({ onContact }) => {
  const { t } = useLang();
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const links = [
    { href: "#layanan", label: t.nav.layanan, id: "layanan" },
    { href: "#paket", label: t.nav.paket, id: "paket" },
    { href: "#hotel", label: t.nav.hotel, id: "hotel" },
    { href: "#kontak", label: t.nav.kontak, id: "kontak" },
  ];

  return (
    <header
      data-testid="navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-[#0C2230]/90 backdrop-blur-xl border-b border-white/10"
          : "bg-transparent"
      }`}
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between gap-4 px-6 py-5 md:px-12 md:py-6 lg:px-16">
        <Logo />

        <nav className="hidden items-center gap-9 md:flex">
          {links.map((l) => (
            <a
              key={l.id}
              href={l.href}
              data-testid={`nav-link-${l.id}`}
              className="text-sm font-medium text-white/75 transition-colors hover:text-white"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <LanguageSwitcher variant="dark" />
          <button
            data-testid="navbar-contact-button"
            onClick={onContact}
            className="hidden rounded-full bg-[#0E9A57] px-5 py-2.5 text-sm font-semibold text-white shadow-sm transition-all hover:bg-[#0c8a4d] hover:shadow-lg md:inline-flex"
          >
            {t.nav.cta}
          </button>
          <button
            data-testid="navbar-mobile-toggle"
            onClick={() => setOpen((v) => !v)}
            className="inline-flex h-9 w-9 items-center justify-center rounded-full border border-white/20 text-white md:hidden"
            aria-label="menu"
          >
            {open ? <X className="h-4 w-4" /> : <Menu className="h-4 w-4" />}
          </button>
        </div>
      </div>

      {open && (
        <div className="border-t border-white/10 bg-[#0C2230]/95 px-6 py-5 md:hidden">
          <div className="flex flex-col gap-4">
            {links.map((l) => (
              <a
                key={l.id}
                href={l.href}
                onClick={() => setOpen(false)}
                data-testid={`nav-link-mobile-${l.id}`}
                className="text-base font-medium text-white/80"
              >
                {l.label}
              </a>
            ))}
            <button
              onClick={() => {
                setOpen(false);
                onContact?.();
              }}
              data-testid="navbar-mobile-contact-button"
              className="mt-2 rounded-full bg-[#0E9A57] px-5 py-3 text-sm font-semibold text-white"
            >
              {t.nav.cta}
            </button>
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;
